import React, { useEffect, useState } from "react"
import axios from "axios"
import { useParams } from "react-router-dom"
import { CardBody, Col, Row, Badge, Card, Button } from "reactstrap"
import BackButton from "components/Common/BackButton"

const Home = () => {
  const { id } = useParams()

  const [dataCount, setData] = useState()

  useEffect(() => {
    const getPlans = async () => {
      try {
        const data = {
          id: id,
        }
        let apiToken = JSON.parse(localStorage.getItem("authUser"))
        const headers = {
          "Content-Type": "application/json",
          Authorization: apiToken,
          Accept: "application/json",
          "Cache-Control": "no-cache",
        }
        const response = await axios.post(
          `https://apidev1.wwingstech.com/superAdmin/viewDataCount`,
          data,
          {
            headers,
          }
        )
        setData(response.data.data)
      } catch (error) {
        console.log(error)
      }
    }
    getPlans()
  }, [id])

  console.log(dataCount)

  return (
    <div id="print-content">
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <div>
                <Card>
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <h3 className="mb-0 card-title flex-grow-1">Counts</h3>
                      <BackButton/>
                    </div>
                  </CardBody>
                  <CardBody>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Customer Count</th>
                          <th scope="col">Policies Count</th>
                          <th scope="col">Leads Count</th>
                          <th scope="col">InsuranceNeed Count</th>
                          <th scope="col">Claim Form Count</th>
                          <th scope="col">MarketingToolDownload Log Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{dataCount ? dataCount.Customer_count : null}</td>
                          <td>{dataCount ? dataCount.Policies_count : null}</td>
                          <td>{dataCount ? dataCount.Leads_count : null}</td>
                          <td>
                            {dataCount ? dataCount.InsuranceNeed_count : null}
                          </td>
                          <td>
                            {dataCount ? dataCount.ClaimForm_Count : null}
                          </td>
                          <td>
                            {dataCount
                              ? dataCount.MarketingToolDownloadLog_Count
                              : null}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Home
